export default __webpack_public_path__ + "static/media/adeola.147206eb.png";